import { render } from "./Pager.vue?vue&type=template&id=3213d547"
import script from "./Pager.vue?vue&type=script&lang=js"
export * from "./Pager.vue?vue&type=script&lang=js"

import exportComponent from "C:\\VS2022\\kirchenbote-online-2022_01\\MD.RMP.KirchenboteOnline.Umb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/Components/Pager.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3213d547"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3213d547', __exports__)) {
    api.reload('3213d547', __exports__)
  }
  
  module.hot.accept("./Pager.vue?vue&type=template&id=3213d547", () => {
    api.rerender('3213d547', render)
  })

}


export default __exports__